export const params = [
  { id: 1, name: 'Стадия' },
  { id: 2, name: 'Этап' },
  { id: 3, name: 'Продажа' },
];

export const modalIds = {
  stage: 1,
  step: 2,
  sale: 3,
};

export const massActionsText = {
  stage: 'Вы изменяете значение "Стадия" жизненного цикла',
  step: 'Вы изменяете значение "Этап" жизненного цикла',
  sale: 'Вы изменяете значение “Продажа” жизненного цикла ',
};
